import { LoggerTransport, LogMessage, LogLevel } from '../logger.model';

export class ConsoleTransport implements LoggerTransport {
  constructor(private options?: any) {}

  sendMessage(message: LogMessage) {
    let style = 'color:black;';

    const logLevel = message.level || LogLevel.Info;

    if (logLevel === LogLevel.Info) {
      style = 'color:#4D33CC;';
    } else if (logLevel === LogLevel.Warning) {
      style = 'color:#EE6400;';
    } else if (logLevel === LogLevel.Error) {
      style = 'color:#F03E3E;';
    } else if (logLevel === LogLevel.Debug) {
      style = 'color:#0078CE;';
    } else if (logLevel === LogLevel.Trace) {
      style = 'color:#20C997;';
    }

    console.log(`%c${message?.message ?? ''}`, style, message);
  }
}
